import { EventI } from "../../pojo/EventI";
import { DataAccess } from "../../dataaccess/data.access";

export interface EventImportRequestDto {
    overrideFolderId?: number;
    overrideCabinetId?: number;
    fallbackFolderId: number;
    fallbackCabinetId: number;
    allowShared: boolean;
    allowBlackoutOverride: boolean;
    allowClosedHoursOverride: boolean;
    events: EventI[];
}

export interface EventImportSaveResponseDto {
    success?: boolean;
    error?: string;
    reservationSaveResponse?: ReservationSaveResponse;
    fallbackEventIds?: number[];
}

export interface ReservationSaveResponse {
    hasConflict?: boolean;
    success?: boolean;
    error?: string;
    conflicts?: Conflicts;
}

export interface Conflicts {
    spConflicts?: SpConflict[];
    rsConflicts?: RsConflict[];
}

export interface SpConflict {
    roomId?: number;
    sharedUse?: boolean;
    conflictType?: ConflictType;
    candidateRsrvStartDt?: string; // LocalDateTime → ISO string
    candidateRsrvEndDt?: string;
    candidateEventId?: number;
    candidateEvDtProfileId?: number;
    candidateRsrvId?: number;
    conflictRsrvStartDt?: string;
    conflictRsrvEndDt?: string;
    conflictEventId?: number;
    conflictEvDtProfileId?: number;
    conflictRsrvId?: number;

    roomName?: string; // front-end only
    conflictTypeName?: string; // front-end only
    candidateDateTimeStr?: string; // front-end only
    conflictDateTimeStr?: string; // front-end only
    candidateEventName?: string; // front-end only
    conflictEventName?: string; // front-end only
}

export interface RsConflict {
    resourceId?: number;
    conflictType?: ConflictType;
    candidateEventId?: number;
    candidateRsrvId?: number;
    candidateRsrvStartDt?: string;
    candidateRsrvEndDt?: string;
    conflictEventId?: number;
    conflictRsrvId?: number;
    conflictRsrvStartDt?: string;
    conflictRsrvEndDt?: string;
    stockLevel?: number;
    reservedTotal?: number;
    overBy?: number;

    resourceName?: string; // front-end only
    conflictTypeName?: string; // front-end only
    candidateDateTimeStr?: string; // front-end only
    conflictDateTimeStr?: string; // front-end only
    candidateEventName?: string; // front-end only
    conflictEventName?: string; // front-end only
}

export type ConflictType = "rsrv" | "pending" | "blackout" | "hours" | "stock";

export class ImportService {
    public static async importEvents(eventImportRequestDto: EventImportRequestDto) {
        return DataAccess.post<EventImportSaveResponseDto>("/import/events.json", eventImportRequestDto);
    }
}
